import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { VerticalCenterBlock, VerticalHorizontalCenterBlock } from '../../../styled';

export const MainContentBox = styled(VerticalCenterBlock)<{ hideBorder?: boolean }>`
  width: 100%;
  flex-direction: column;
  padding: 32px 0 32px 0;
  border-bottom: ${(props) =>
    props.hideBorder ? 'none' : `1px solid ${props.theme.colors.stroke}`};
`;

export const CheckBoxListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const SyncUserWrapper = styled(VerticalHorizontalCenterBlock)`
  padding-top: 16px;
`;

export const ThinContentBox = styled.div`
  width: 468px;
`;

export const WrapperNotification = styled.div`
  margin-bottom: 16px;
`;

export const NotificationLink = styled(Link)`
  text-decoration: underline;
  font-weight: 500;
  color: ${(props) => props.theme.colors.brand};
`;

export const NotificationCustom = styled.a`
  color: ${(props) => props.theme.colors.brand};
  text-decoration: underline;
`;
